const footerHeaders = document.getElementsByClassName('footer-block__heading');

for (const header of footerHeaders) {
  header.addEventListener("click", (event) => {
    if(window.screen.width <= 750) {
      header.classList.toggle("rotate");
      const footerHeaderParent = header.parentElement;
      let allChildren = footerHeaderParent.children;
  
      var filteredChildren = Array.from(allChildren).filter(function(child) {
        return !child.classList.contains("footer-block__heading");
      });
  
      for (let i = 0; i < filteredChildren.length; i++) {
        const currentChild = filteredChildren[i];
        currentChild.classList.toggle("hide-footer");
        currentChild.classList.toggle("show-footer");
      }
    }
  });
}